import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash-es';
import { processNextAvailableSlots } from 'utils';
import { SlotsContainer } from 'shared';

const Root = styled(SlotsContainer)`
  display: flex;
  margin: 5px 0 8px;
  overflow: auto;
`;

function Slots({
  onlineSchedule = {},
  nextSlotDate,
  doctor = {},
  onClick,
}: any) {

  const [processedSlots, setProcessedSlots] = useState<any>([]);
  const [totalSlots, setTotalSlots] = useState<any>(0);

  useEffect(() => {
    if (!isEmpty(onlineSchedule.shifts)) {
      const { slots, totalSlots }: any = processNextAvailableSlots({
        shifts: onlineSchedule?.shifts, date: nextSlotDate, doctor,
      });
      setProcessedSlots(slots[0] || []);
      setTotalSlots(totalSlots);
    }

  }, [onlineSchedule]);

  return (
    <Root
      showMoreSlotCard={totalSlots > 6}
      slots={processedSlots?.slice(0, 6)}
      onClick={onClick}
    />
  );
}

export default Slots;

